import React from "react";
import { Accordion } from "@gcs/design-system/react";

import Button from "components/common/Button";

import useWindowSize from "hooks/useWindowSize";

import { ReactComponent as DownloadIcon } from "assets/svgs/download-icon.svg";

import envs from "config/envs";

import * as S from "./SectionPublications.Style";

const publicationList = [
  {
    id: 1,
    title: "Códigos",
    links: [
      {
        id: "1-1",
        label: "Código de Ética e Conduta",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/Code%20de%20conduite%20Groupe%20C@pEthic%20-%20Site%20institutionnel%20-%20anglais%20-%20avril%202022.pdf?_ga=2.176611757.92447727.1667843332-542798228.1660054478`,
      },
      {
        id: "1-2",
        label: "Código de Ética e Conduta CNP Seguros Holding Brasil",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/CNP_21_C%C3%B3digo_de_%C3%89tica.pdf?_ga=2.176611757.92447727.1667843332-542798228.1660054478`,
      },
      {
        id: "1-3",
        label:
          "Código de Ética e Conduta dos Prestadores de Serviços e Parceiros de negócio da CNP Brasil",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/CNP_21_C%C3%B3digo_de_%C3%89tica_Fornecedor.pdf?_ga=2.207677082.92447727.1667843332-542798228.1660054478`,
      },
    ],
  },
  {
    id: 2,
    title: "Cartilhas",
    links: [
      {
        id: "2-1",
        label: "Cartilha de Prevenção à Fraude",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/CNP_CARTILHA_FRAUDE_0811.pdf?_ga=2.216509086.92447727.1667843332-542798228.1660054478`,
      },
      {
        id: "2-2",
        label:
          "Cartilha de Prevenção à Lavagem de Dinheiro e Combate ao Terrorismo",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/CARTILHA_LAVAGEM_DINHEIRO%200811%20vs%20FINAL_%20INTERNET.pdf?_ga=2.216509086.92447727.1667843332-542798228.1660054478`,
      },
      {
        id: "2-3",
        label: "Cartilha Anticorrupção",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/CNP_CARTILHA_ANTI-CORRUPCAO_0811.pdf?_ga=2.174006315.92447727.1667843332-542798228.1660054478`,
      },
    ],
  },
  {
    id: 3,
    title: "Outros documentos",
    links: [
      {
        id: "3-1",
        label: "Política de Sustentabilidade",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/PO%20011%2009%20-%20Pol%C3%ADtica%20de%20Sustentabilidade.pdf`,
      },
      {
        id: "3-2",
        label: "Guia de Uso Aceitável",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/GUIA%20SGI%20004%2001%20-%20Guia%20de%20Uso%20Aceit%C3%A1vel%20de%20Recursos%20Tecnol%C3%B3gicos.pdf?_ga=2.153060785.92447727.1667843332-542798228.1660054478`,
      },
      {
        id: "3-3",
        label: "Política Anticorrupção",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Política_Anticorrupcao-CSH.pdf`,
      },
      {
        id: "3-4",
        label: "Política de Tratamento de Relatos do Canal de Ética",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Politica_Tratamento_Relatos_Canal_Etica.pdf`,
      },
      {
        id: "3-5",
        label:
          "Política de Tratamento de Relacionamento com a Administração Pública",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Politica_de_Relacionamento_com_a_Administracao_Publica.pdf`,
      },
      {
        id: "3-6",
        label: "Política de Transações entre Partes Relacionadas",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Politica_de_Transacoes_entre_Partes_Relacionadas.pdf`,
      },
      {
        id: "3-7",
        label: "Interações com a Administração Pública",
        href: `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Interacoes_com_a_Administracao_Publica.pdf`,
      },
    ],
  },
];

const SectionPublications = () => {
  const { width } = useWindowSize();
  const isMobile = width && width <= 1024;

  return (
    <S.SectionPublicationsContainer className="container">
      <S.SectionPublicationsBlock>
        <S.SectionPublicationsTitle>Publicações</S.SectionPublicationsTitle>

        <S.SectionPublicationsDescription>
          Aqui você encontra materiais informativos sobre temas essenciais, como
          prevenção à fraude, além de documentos que reforçam nosso compromisso
          com a ética, a sustentabilidade e o uso seguro dos recursos
          tecnológicos disponíveis para quem interage com a gente. Confira!
        </S.SectionPublicationsDescription>
      </S.SectionPublicationsBlock>

      <S.SectionPublicationsList>
        {!isMobile ? (
          publicationList.map((publication) => (
            <S.SectionPublicationsItem key={publication.id}>
              <S.SectionPublicationsItemTitle>
                {publication.title}
              </S.SectionPublicationsItemTitle>

              {publication.links.map((link) => (
                <Button as="a" key={link.id} href={link.href} target="_blank">
                  <DownloadIcon /> <span>{link.label}</span>
                </Button>
              ))}
            </S.SectionPublicationsItem>
          ))
        ) : (
          <Accordion>
            {publicationList.map((publication) => (
              <S.SectionPublicationsAccordionItem
                key={publication.id}
                title={publication.title}
              >
                <S.SectionPublicationsAccordionItemList>
                  {publication.links.map((link) => (
                    <S.SectionPublicationsItemLink
                      href={link.href}
                      key={link.id}
                      target="_blank"
                    >
                      <DownloadIcon /> <span>{link.label}</span>
                    </S.SectionPublicationsItemLink>
                  ))}
                </S.SectionPublicationsAccordionItemList>
              </S.SectionPublicationsAccordionItem>
            ))}
          </Accordion>
        )}
      </S.SectionPublicationsList>
    </S.SectionPublicationsContainer>
  );
};

export default SectionPublications;
